interface LogoProps {
  size?: number;
  className?: string;
}

/**
 * BackStage logo: three stacked rounded layers, suggesting tiers /
 * back-of-stage scenery. Geometric and quiet enough to live next to
 * the wordmark without competing with it.
 */
export function Logo({ size = 22, className }: LogoProps) {
  return (
    <span
      className={className}
      style={{ width: size, height: size, display: "inline-flex" }}
      aria-hidden="true"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="bs-grad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#98a6ff" />
            <stop offset="100%" stopColor="#5b6fdb" />
          </linearGradient>
        </defs>
        <rect
          x="3"
          y="14.5"
          width="18"
          height="5"
          rx="1.5"
          fill="url(#bs-grad)"
          opacity="0.45"
        />
        <rect
          x="5"
          y="9"
          width="14"
          height="5"
          rx="1.5"
          fill="url(#bs-grad)"
          opacity="0.7"
        />
        <rect
          x="7.5"
          y="3.5"
          width="9"
          height="5"
          rx="1.5"
          fill="url(#bs-grad)"
        />
      </svg>
    </span>
  );
}
